import type { RootState } from 'reducers/index';

export const getRoot = (state: RootState) => state;

export const getProps = <T>(_: unknown, props: NoInfer<T>) => props;

export const getSecondProps = <T>(_: unknown, __: unknown, props: NoInfer<T>) => props;

export const getThirdProps = <T>(_: unknown, __: unknown, ___: unknown, props: NoInfer<T>) => props;
